export default class HelpCenterController {
  static getOverview(helpCenterId: string) {
    return fetch(`/api/${helpCenterId}/overview`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getCollection(helpCenterId: string, collectionId: string) {
    return fetch(`/api/${helpCenterId}/collections/${collectionId}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getArticle(helpCenterId: string, articleId: string) {
    return fetch(`/api/${helpCenterId}/articles/${articleId}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static search(helpCenterId: string, search: string) {
    return fetch(`/api/${helpCenterId}/search?search=${search}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
}